import { PageTitleH2 } from "./styles";

const PageTitle = ({ title }) => {
  return <PageTitleH2>{title}</PageTitleH2>;
};

export default PageTitle;
